import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Container, Row, Col } from "react-bootstrap";

import "./CdCalendarExceptionsModal.scss"
import messages from '../../assets/i18n'
import { ButtonStandard } from "../";

function CdCalendarExceptionsModal(props) {

	const dispatch = useDispatch();

	const cdId = useSelector(state => state.cdDetails.cdSelect);
	const lang = useSelector(state => state.language.name);

	const [title, setTitle] = useState("");

	const [titleIsEmpty, setTitleIsEmpty] = useState(false);

	const [date, setDate] = useState("");

	const [dateIsEmpty, setDateIsEmpty] = useState(false);


	const handleDateFormat = () => (e) => {
		
		if(e.target.value.length > 10){
			e.target.value = "0000-00-00";
		}

		setDate(e.target.value);
	}

	const dispatchExceptions = () => {
		if (title.trim() === "" || date === "") {
			if (title.trim() === "") {
				setTitleIsEmpty(true)
			} else {
				setTitleIsEmpty(false)
			}

			if (date === "") {
				setDateIsEmpty(true)
			} else {
				setDateIsEmpty(false)
			}

		} else {
			dispatch({
				type: "POST_CD_EXCEPTION",
				id: cdId,
				date: date,
				description: title
			});

			props.onHide(() => false)
		}
	}

	return (
		<Modal
			{...props}
			aria-labelledby="contained-modal-title-vcenter"
			className="cd-calendar-exceptions-modal"
			centered
		>
			<Modal.Header className="text-left" closeButton>
				<Modal.Title className="w-100 font-weight-bold">
					{messages[lang].includeException}
			</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Container fluid className="px-0">
					<div className="div-background"></div>
					<Row>
						<Col className="mb-3 mt-2">
							<input
								type="text"
								className="input-title"
								id="cd_calendar_exceptions_modal_title"
								onChange={e => setTitle(e.target.value)}
								placeholder={messages[lang].includeTitle}
								required={true}
							/>
							<p className={`error-${titleIsEmpty}`}>{messages[lang].requiredField}</p>
						</Col>
					</Row>
					<Row>
						<Col>
							<p className="mb-0 font-weight-bold">{messages[lang].date}</p>
							<input
								type="date"
								className="date-input"
								id="cd_calendar_exceptions_modal_date"
								onChange={handleDateFormat()}
								required={true}
							/>
							<p className={`error-${dateIsEmpty}`}>{messages[lang].requiredField}</p>
						</Col>
					</Row>

				</Container>

			</Modal.Body>
			<Modal.Footer>
				<ButtonStandard
					id="load_modal_add_order_button"
					text={messages[lang].save}
					textClass="text-3"
					//isLoading={this.state.buttonLoading}
					className="btn btn-primary btn-standard px-4 py-1"
					onClick={() => dispatchExceptions()}
				/>
			</Modal.Footer>
		</Modal>
	)
}

export default CdCalendarExceptionsModal;